import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Common Entities => form => ');

/**
 * actions for fecthing forms
 */
const fetchExperienceForm = createAction('fetch form by form id', (formId) => ({ formId }));
const fetchContainerForms = createAction('fetch container forms', (containerRef, typeRef, subTypeRef) => ({
  containerRef,
  typeRef,
  subTypeRef,
}));
const fetchLibraryForms = createAction('fetch library forms', (offset, max) => ({ offset, max }));
const fetchFormsFailure = createApiFailureAction('failed to fetch forms');
const fetchFormsSuccess = createAction('succesfully fetched forms', (forms) => ({
  forms,
}));

/**
 * actions for saving forms
 */
const saveForms = createAction('save forms', (unsavedLayouts) => ({ unsavedLayouts }));
const applyForms = createAction('apply forms', (unsavedLayouts) => ({ unsavedLayouts }));
const finishSaving = createAction('finish saving');
const saveFormsFailure = createApiFailureAction('failed to save forms');
const saveFormsSuccess = createAction('succesfully saved form', (closeDesigner) => ({ closeDesigner }));
const receiveUpdatedForm = createAction('receive an updated form from the form save api', (form) => ({ form }));

/**
 * actions for creating a new form
 */
const createNewForm = createAction('create new form', (form) => ({ form }));
const createNewFormFailure = createApiFailureAction('failed to create a new form');
const createNewFormSuccess = createAction('create new form success', (formId) => ({ formId }));

const addFormConfig = createAction('add form config to forms', (form) => ({ form }));

export default {
  fetchExperienceForm,
  fetchContainerForms,
  fetchLibraryForms,
  fetchFormsSuccess,
  fetchFormsFailure,
  saveForms,
  applyForms,
  finishSaving,
  saveFormsFailure,
  saveFormsSuccess,
  receiveUpdatedForm,
  createNewForm,
  createNewFormFailure,
  createNewFormSuccess,
  addFormConfig,
};
